import * as React from 'react';
import { getQueryStringParams,SearchSelect, SearchInput, DateInput} from "../../../common";
import API from "../../../common/AxoisClient";
const moment = require('moment');

interface IState {
  form: {
    like: {
      user: string;
      created_at: string;
      system_notification_id: number | "";

    };
  };
  titles: Array<{ id: number; title: string }>;
}

export default class CompanyFilter extends React.Component<any, IState> {
  state: IState;

  UNSAFE_componentWillMount() {
    let old_data: any = getQueryStringParams("form");
    old_data = JSON.parse(old_data);
    this.setState({form:  {
            like: {
                user: old_data ? old_data.like.user : '',
                created_at: old_data?.like?.created_at || '',
                system_notification_id: old_data?.system_notification_id || "",
            },
        },
       titles: []
      });
      API.get("settings/system-notifications",{ params: { skip_pagination: true } })
      .then((response) => {
        const titles = response.data.data.map((item: any) => ({ id: item.id, title: item.title }));
        this.setState({ titles });
      })
      .catch((error) => {
        console.error("Error fetching titles:", error);
      });
}

  handleInputForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name.split(".");
    const newAccess: any = { ...this.state.form };
    if (name.length > 2) {
      newAccess[name[1]] = { ...newAccess[name[1]], [name[2]]: e.target.value };
    } else {
      newAccess[name[1]] = e.target.value;
    }
    this.setState({form: newAccess},() =>  this.props.getResults(this.state.form));
  }

  

  render(){
   return (
      <div className="row align-items-center">
 
     <SearchInput name={'form.like.user'} value={this.state.form.like.user} placeholder={'Enter user'} onChange={this.handleInputForm} />
     <SearchSelect name={'form.like.system_notification_id'} value={this.state.form.like.system_notification_id} onChange={this.handleInputForm}
     options={[{ label: "Select title", value: "" },...this.state.titles.map((t) => ({ label: t.title, value: t.id }))]}/>
     <DateInput name={'form.like.created_at'} value={this.state.form.like.created_at} placeholder={'Search date'} onChange={this.handleInputForm} readOnly={false}/></div>
    )
  }
}